import React, { lazy } from "react";
import { mainRoutes } from "./mainRoutes";
import { authRoutes } from "@/features/auth/routes/authRoutes";
import RouterErrorBoundary from "../errors/RouterErrorBoundary/RouterErrorBoundary";

const NotFound = lazy(() => import("../errors/NotFound/NotFound"));

export const routerConfig = [
  ...mainRoutes,
  ...authRoutes,
  
  {
    path: "*",
    element: <NotFound />,
    errorElement: <RouterErrorBoundary />,
  },
];
